// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"435a0b72","530":"c2483dc6","562":"0410fd42","673":"2b4f0e80"}[chunkId] + ".chunk.js";
};